<template>
    <div id="app">
        <!-- <Header class="header"/> -->
        <!-- <div class="main"> -->
        <notifications group="foo" position="top center" />
        <router-view></router-view>
        <Modal v-show="statusLogin">
            <template v-slot:header> </template>
            <template v-slot:body>
                Maaf Anda tidak aktif selama 15 menit silahkan login kembali
            </template>
            <template v-slot:footer>
                <button class="btn-primer" @click="logout">Login</button>
            </template>
        </Modal>
        <!-- </div> -->
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import axios from "axios";
import Modal from "./assets/Modal.vue";

export default {
    name: "app",
    components: {
        // HelloWorld
        // Header
        Modal,
    },
    data() {
        return {
            username: "",
            photo: "",
            periode: 600,
            status: "",
            timeoutId: null,
            timeoutInMS: 10 * 1000,
            events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
            statusLogin: false,
        };
    },
    computed: {
        isLogin() {
            return this.$store.getters.isAuthenticated;
        },
        userProfil() {
            return localStorage.getItem("username");
        },
    },
    mounted() {
        let token = localStorage.getItem("token");

        if (token) {
            this.events.forEach((event) => {
                window.addEventListener(event, this.resetTimer);
            }, this);

            this.startTimer();
        }
    },
    created() {
        let token = localStorage.getItem("token");
        if (token) {
            const cekStatus = setInterval(() => {
                if (!token) {
                    clearInterval(cekStatus);
                }
                localStorage.setItem("status_token", false);
                let newStatus = localStorage.getItem("status_token");
                this.tokenRefresh(newStatus);
            }, 2.5 * 60 * 1000);
        }
    },
    methods: {
        handleInactive() {
            this.statusLogin = true;
            clearTimeout(this.timeoutId);
        },

        startTimer() {
            this.timeoutId = setTimeout(this.handleInactive, 14 * 60 * 1000);
        },

        resetTimer() {
            clearTimeout(this.timeoutId);
            this.startTimer();
        },
        setupTimers() {
            this.startTimer();
        },
        boom() {
            if (this.periode !== 300) {
                this.periode = 300;
            } else {
                this.periode = 600;
            }
        },
        logout() {
            localStorage.clear();
            delete axios.defaults.headers.common["Authorization"];
            window.location.href = "/login";
            this.statusLogin = false;
        },
        refreshToken() {
            let role = localStorage.getItem("role");
            let url = "";
            const intervalRefreshToken = setInterval(() => {
                const token = localStorage.getItem("token");
                if (!token) {
                    clearInterval(intervalRefreshToken);
                }

                if (role == 5 || role == 16) {
                    url = "/v1/counter/refresh";
                } else if (role == 13) {
                    url = "/v1/clearing/refresh";
                } else {
                    url = "/v1/user/refresh";
                }

                let refreshTokenTime = Number(localStorage.getItem("refreshTokenTime"));
                if (refreshTokenTime !== undefined && refreshTokenTime != 0 && Date.now() > refreshTokenTime && this.status != "loading") {
                    this.status = "loading";
                    axios({
                        method: "get",
                        url: url,
                    })
                        .then((response) => {
                            this.status = "success";
                            const newToken = response.data.data.token;
                            axios.defaults.headers.common["Authorization"] = "Bearer " + newToken;
                            localStorage.setItem("token", newToken);
                            localStorage.setItem("refreshTokenTime", Date.now() + 90000); //3 minutes
                        })
                        .catch((e) => {
                            console.log(e.response);
                        });

                    // clearInterval(intervalRefreshToken)
                }
            }, 1000);
        },

        tokenRefresh(tokenStatus) {
            // console.log(tokenStatus);
            let role = localStorage.getItem("role");
            let url = "";
            if (role == 5 || role == 16) {
                url = "/v1/counter/refresh";
            } else if (role == 13) {
                url = "/v1/clearing/refresh";
            } else {
                url = "/v2/user/refresh";
            }
            if (tokenStatus == "false") {
                axios.get(url).then((res) => {
                    const newToken = res.data.data.token;
                    axios.defaults.headers.common["Authorization"] = "Bearer " + newToken;
                    localStorage.setItem("token", newToken);
                });
                localStorage.setItem("status_token", true);
            }
        },
    },
};
</script>

<style>
#app {
    font-family: "Nunito", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #707070;
    /* font-size: clamp(0.25rem, 0.25rem + 1.5vw, 0.75rem); */
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

a {
    text-decoration: none;
    color: #707070;
}

a:hover {
    text-decoration: none;
}

:root {
    --primary: #1f354a;
    --hover: #997528;
    --scondary: #c59733;
}

button:focus {
    outline: none;
}

.top-squence {
    width: 85%;
    border-radius: 10px 10px 0 0;
    margin: 0 auto;
    background: #000e22;
    padding: 29px 20px;
    font-size: 14px;
}

.top-squence ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0;
}

.top-squence ul li {
    list-style: none;
    text-align: center;
    font-size: 10px;
    color: #40688e;
    position: relative;
    width: 91px;
}

.top-squence ul li div {
    background: transparent;
    border: solid 0.1px #40688e;
    color: #40688e;
    border-radius: 50%;
    width: 27px;
    font-size: 16px;
    font-weight: 600;
    margin: 2px auto;
}

.li-active {
    color: #c59733 !important;
}

.top-squence ul li span,
.li-active span {
    display: none;
}

.top-squence ul li div.squnce-active {
    position: relative;
    background: #c59733;
    color: #000e22;
    border: solid 0.5px #c59733;
}

.top-squence ul li div.squnce-process {
    position: relative;
    border: solid 0.5px #c59733;
    color: #c59733;
}

.error {
    color: #e74c3c;
    font-size: 13px;
    padding: 15px;
}

.succes {
    color: #2ecc71;
    font-size: 13px;
}

.self-modal {
    z-index: 999;
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0;
    right: -17px;
    width: 102%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}

.content-modal {
    background: white;
    position: relative;
    width: 800px;
    margin: 5% auto;
    padding: 20px;
    border-radius: 10px;
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s;
}

/* Add Animation */
@-webkit-keyframes animatetop {
    from {
        top: -300px;
        opacity: 0;
    }
    to {
        top: 0;
        opacity: 1;
    }
}

@keyframes animatetop {
    from {
        top: -300px;
        opacity: 0;
    }
    to {
        top: 0;
        opacity: 1;
    }
}

.title-modal {
    height: 50px;
    /* border: inherit; */
    font-size: 20px;
    font-weight: bold;
}

.footer-modal {
    margin: 50px 22px 10px;
}

.footer-modal div {
    width: 100%;
    text-align: center;
    line-height: 3;
}

.modal-header .modal-body .modal-footer {
    padding: 1rem 1.7rem !important;
}

.modal-body {
    font-size: 14px;
}

.modal-title {
    font-weight: bold;
}

.modal-footer .btn {
    border-radius: 25px;
}

.dropdown-link {
    border: solid 1px rgba(112, 112, 112, 0.4);
    -webkit-box-shadow: 0 0px 5px 0 rgba(10, 10, 10, 0.76);
    box-shadow: 0 0px 2px 0 rgba(1, 2, 5, 0.55);
    width: 170px;
    padding: 5px 15px;
    display: none;
}

.dropdown-link li {
    list-style: none;
}

.dropdown-link li:hover {
    color: #1f354a;
}

nav ul li:hover ul {
    display: block;
    position: absolute;
    right: 16px;
    top: 40px;
    background: white;
}

.sub-nav {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.sub-nav-login {
    display: flex;
    justify-content: flex-end;
    width: 100%;
}

.sub-nav-login .nav-link {
    line-height: 2.5;
    cursor: pointer;
}
f .logo-user {
    width: 38px;
}

.form-input {
    font-size: 13px;
    font-family: "Poppins", sans-serif;
    height: 45px;
    border-radius: 7px;
    border: none;
    /* text-transform: capitalize; */
    background: #f8f9fe;
    color: #707070;
    padding: 0 20px;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-input:focus {
    color: #707070;
    background-color: #f8f9fe;
    outline: 0;
    z-index: 3;
    box-shadow: 0 4px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-input-error:focus {
    border-color: #e74c3c !important;
    box-shadow: 0 0 0 0.15rem rgba(231, 76, 60, 0.25);
}

/* 46, 204, 113 */

.form-input-succes,
.form-input-succes:focus {
    background: url("./assets/check-mark.svg") no-repeat right;
    /* border-color: #2ecc71 !important; */
    /* border: solid 1px #2ecc71; */
    background-size: 18px;
    background-origin: content-box, content-box;
    box-shadow: 0 4px 3px rgb(46 204 113 / 15%), 0 1px 0 rgb(46 204 113 / 2%);
}

.form-input-succes::after {
    content: "";
    border: solid black;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

::placeholder {
    color: rgba(112, 112, 112, 0.5);
}

.form-group {
    margin: 0 0 22px;
    position: relative;
}

.form-group select {
    font-size: 13px;
    font-family: "Poppins", sans-serif;
    color: #495057;
    border-radius: 7px;
    border: none;
    /* background-color: #f8f9fe; */
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
    padding: 0 20px;
    background: url("./assets/br_down.png") no-repeat right #f8f9fe;
    background-position-x: 96.6%;
    background-size: 11px;
    -webkit-appearance: none;
}

.form-group select:focus {
    color: #495057;
    background-color: #f8f9fe;
    border-color: #6454f0;
    outline: 0;
    /* rgba(251, 140, 0, 1) */
    box-shadow: 0 4px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

textarea {
    resize: none;
    border: solid 2px rgba(112, 112, 112, 0.5);
    border-radius: 5px;
    margin-top: 15px;
    padding: 5px 10px;
    width: 100%;
}

.logo {
    width: 219px;
    height: 62px;
    background-color: #1f354a;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 3.3;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
}

.logo:hover {
    text-decoration: none;
}

nav {
    display: flex !important;
    border-bottom: solid 1px rgba(112, 112, 112, 0.4);
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 62px;
    box-shadow: 0 -3px 5px 0 rgba(10, 10, 10, 0.76);
}

.links {
    display: flex;
    justify-content: space-between;
    width: 20%;
    position: relative;
    font-size: 14px;
    margin: 0;
}

.nav-link {
    list-style: none;
}

.buttons {
    border: solid 1px transparent;
    padding: 5px 15px;
    border-radius: 10px;
    font-size: 12px;
    margin: 5px;
}

.btn-primer {
    width: 160px;
    max-width: 200px;
    height: 45px;
    border-radius: 0.25rem;
    background-color: #c59733;
    font-size: 16px;
    font-weight: bold;
    color: white;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}

.btn-primer:hover {
    /* background-color: #997528; */
    /* border: solid 1px #594BD6; */
    transform: translateY(-1px);
    box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}

.btn-primer:focus {
    color: #ffffff;
    background-color: #997528;
    border-color: #997528;
    outline: 0;
    /* rgba(251, 140, 0, 1) */
    box-shadow: 0 0 0 0.3rem rgba(100, 84, 240, 0.25);
}

.btn-primer[disabled] {
    opacity: 50%;
    cursor: not-allowed;
    /* pointer-events: none; */
}

.btn-scondary {
    width: 160px;
    max-width: 200px;
    height: 45px;
    border-radius: 0.25rem;
    background-color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    color: #c59733;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);

    /* cursor: pointer;
  width: 160px;
  height: 50px;
  border-radius: 25px;
  border: solid 1px #c59733;
  font-size: 16px;
  font-weight: bold;
  color: #c59733;
  background: #ffffff; */
}

.btn-scondary:hover {
    /* background-color: #997528; */
    /* color: #c59733; */
    /* border: solid 1px #997528; */
    transform: translateY(-1px);
    box-shadow: 0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}

.btn-scondary:focus {
    color: #495057;
    background-color: #fff;
    border-color: #6454f0;
    outline: 0;
    /* rgba(251, 140, 0, 1) */
    box-shadow: 0 0 0 0.3rem rgba(100, 84, 240, 0.25);
}

.container-outline {
    width: 88%;
    margin: auto;
}

.container {
    width: 80%;
    margin: auto;
}

.ketentuan {
    font-weight: bold;
    cursor: pointer;
}

/* radio button */

.radio {
    display: inline-flex;
    line-height: 40px;
    margin-left: -15px;
    cursor: pointer;
}

.radio input {
    width: 1px;
    height: 1px;
    opacity: 0;
}

.radio input:checked + .outer .inner {
    -webkit-transform: scale(0.7);
    -ms-transform: scale(0.7);
    transform: scale(0.7);
    opacity: 1;
}

.radio input:checked + .outer {
    border: 2px solid #6454f0;
}

.radio input:focus + .outer .inner {
    -webkit-transform: scale(0.7);
    -ms-transform: scale(0.7);
    transform: scale(0.7);
    opacity: 1;
    background-color: #6454f0;
}

.radio .outer {
    width: 20px;
    height: 20px;
    display: block;
    float: left;
    margin: 10px 9px 10px 10px;
    border: 1.5px solid #ddd;
    border-radius: 50%;
    background-color: #fff;
}

.radio .inner {
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    width: 16px;
    height: 16px;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    display: block;
    margin: 0px;
    border-radius: 50%;
    background-color: #6454f0;
    opacity: 0;
}

/* animation radio */

@-webkit-keyframes cardEnter {
    0%,
    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
    }
    20% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1);
    }
    40% {
        -webkit-transform: scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
    }
    80% {
        -webkit-transform: scale3d(0.97, 0.97, 0.97);
    }
    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
    }
}

@keyframes cardEnter {
    0%,
    20%,
    40%,
    60%,
    80%,
    100% {
        -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
        transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    20% {
        -webkit-transform: scale3d(1.1, 1.1, 1.1);
        transform: scale3d(1.1, 1.1, 1.1);
    }
    40% {
        -webkit-transform: scale3d(0.9, 0.9, 0.9);
        transform: scale3d(0.9, 0.9, 0.9);
    }
    60% {
        opacity: 1;
        -webkit-transform: scale3d(1.03, 1.03, 1.03);
        transform: scale3d(1.03, 1.03, 1.03);
    }
    80% {
        -webkit-transform: scale3d(0.97, 0.97, 0.97);
        transform: scale3d(0.97, 0.97, 0.97);
    }
    100% {
        opacity: 1;
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}

/* end radio button */

.label--checkbox {
    /* position: absolute; */
    margin-left: 30px;
    font-size: 14px;
    /* line-height: 158%;
  margin-top: -5px; */
    font-weight: normal;
    width: 95% !important;
    margin-right: 10px;
}

.checkbox {
    position: relative;
    /* top: -0.375rem; */
    /* margin: 0 1rem 0 0; */
    cursor: pointer;
    display: inline-block;
}

.checkbox:before {
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    content: "";
    position: absolute;
    left: 0;
    z-index: 2;
    width: 13px;
    height: 13px;
    border: 2px solid #dddddd;
}

.checkbox:checked:before {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    height: 0.5rem;
    border-color: #6454f0;
    border-top-style: none;
    border-right-style: none;
}

.checkbox:after {
    content: "";
    position: absolute;
    /* top: -0.125rem; */
    left: 0;
    width: 1.3rem;
    height: 2rem;
    background: #fff;
    cursor: pointer;
}

@media (min-width: 768px) and (max-width: 1023px) {
    .label--checkbox {
        margin-left: 10px;
    }
}

@media (max-width: 768px) {
    .self-modal {
        right: 0;
        width: 100%;
    }

    .content-modal {
        width: 95%;
    }

    /* .li-active::before {
    width: 10px;
    top: 45%;
    left: -5px;
  } */
    .top-squence ul li div {
        width: 24px;
        font-size: 14px;
    }
}
</style>
